import { ActionInfo } from "./ActionInfoTypes";

// -----
// *** BRICK PACK ACTIONS ***
// -----

export const BrickPack_SlopedBricksPartOne: ActionInfo = {
  id: "brickpack_sloped_bricks_part_one",
  type: "BrickPack",
  title: "Sloped Bricks #1",
  details: "Sloped Bricks #1",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 15,
    },
    {
      brickId: "3024",
      baseChangeValue: 15,
    },
    {
      brickId: "3023",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "54200",
      baseChangeValue: 0.9,
    },
    {
      brickId: "3040",
      baseChangeValue: 0.75,
    },
    {
      brickId: "4286",
      baseChangeValue: 0.75,
    },
    {
      brickId: "60477",
      baseChangeValue: 0.75,
    },
    {
      brickId: "3039",
      baseChangeValue: 0.5,
    },
    {
      brickId: "30363",
      baseChangeValue: 0.5,
    },
    {
      brickId: "3660",
      baseChangeValue: 0.5,
    },
    {
      brickId: "2752",
      baseChangeValue: 0.4,
    },
    {
      brickId: "30390",
      baseChangeValue: 0.4,
    },
    {
      brickId: "6091",
      baseChangeValue: 0.4,
    },
  ],
  actionVisibility: [
    {
      actionId: "create_3010",
    },
    {
      actionId: "create_3003",
    },
    {
      actionId: "create_3001",
    },
    {
      actionId: "split_3001_into_3020",
    },
    {
      actionId: "split_3003_into_3022",
    },
    {
      actionId: "split_3010_into_3710",
    },
  ],
  isBrickpack: true,
};

export const BrickPack_MinifigUtensilsPartOne: ActionInfo = {
  id: "brickpack_minifig_utensils_part_one",
  type: "BrickPack",
  title: "Minifig Utensils #1",
  details: "Minifig Utensils #1",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 15,
    },
    {
      brickId: "3003",
      baseChangeValue: 15,
    },
    {
      brickId: "3020",
      baseChangeValue: 15,
    },
    {
      brickId: "3660",
      baseChangeValue: 7,
    },
    {
      brickId: "3040",
      baseChangeValue: 7,
    },
    {
      brickId: "60477",
      baseChangeValue: 7,
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "4349",
      baseChangeValue: 0.9,
    },
    {
      brickId: "30162",
      baseChangeValue: 0.75,
    },
    {
      brickId: "30228",
      baseChangeValue: 0.75,
    },
    {
      brickId: "6246a",
      baseChangeValue: 0.5,
    },
    {
      brickId: "30148",
      baseChangeValue: 0.5,
    },
    {
      brickId: "93106",
      baseChangeValue: 0.3,
    },
    {
      brickId: "4449",
      baseChangeValue: 0.3,
    },
    {
      brickId: "30304",
      baseChangeValue: 0.3,
    },
    {
      brickId: "3962a",
      baseChangeValue: 0.3,
    },
    {
      brickId: "3835",
      baseChangeValue: 0.3,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3005_10",
    },
    {
      actionId: "auto_collect_3004_10",
    },
    {
      actionId: "auto_collect_3024_10",
    },
    {
      actionId: "auto_collect_3023_10",
    },
  ],
  isBrickpack: true,
};

export const BrickPack_BioniclesPartOne: ActionInfo = {
  id: "brickpack_bionicles_part_one",
  type: "BrickPack",
  title: "Bionicles #1",
  details: "Bionicles #1",
  cost: [
    {
      brickId: "3001",
      baseChangeValue: 40,
    },
    {
      brickId: "3710",
      baseChangeValue: 40,
    },
    {
      brickId: "3020",
      baseChangeValue: 40,
    },
    {
      brickId: "30162",
      baseChangeValue: 5,
    },
    {
      brickId: "30304",
      baseChangeValue: 5,
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "x346",
      baseChangeValue: 0.75,
    },
    {
      brickId: "42074",
      baseChangeValue: 0.75,
    },
    {
      brickId: "32553",
      baseChangeValue: 0.75,
    },
    {
      brickId: "42760",
      baseChangeValue: 0.5,
    },
    {
      brickId: "32506",
      baseChangeValue: 0.5,
    },
    {
      brickId: "42042",
      baseChangeValue: 0.5,
    },
    {
      brickId: "43558",
      baseChangeValue: 0.5,
    },
    {
      brickId: "41671",
      baseChangeValue: 0.3,
    },
    {
      brickId: "54271",
      baseChangeValue: 0.3,
    },
    {
      brickId: "47298",
      baseChangeValue: 0.3,
    },
  ],
  actionVisibility: [
    {
      actionId: "upgrade_brickpack_sloped_bricks_part_one",
    },
    {
      actionId: "upgrade_brickpack_minifig_utensils_part_one",
    },
    {
      actionId: "upgrade_brickpack_bionicles_part_one",
    },
  ],
  isBrickpack: true,
};

export const BrickPack_AnimalsPartOne: ActionInfo = {
  id: "brickpack_animals_part_one",
  type: "BrickPack",
  title: "Animals #1",
  details: "Animals  #1",
  cost: [
    {
      brickId: "3710",
      baseChangeValue: 200,
    },
    {
      brickId: "3010",
      baseChangeValue: 200,
    },
    {
      brickId: "43558",
      baseChangeValue: 7,
    },
    {
      brickId: "54271",
      baseChangeValue: 7,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 10,
      type: "set",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "4493c01pb02",
      baseChangeValue: 0.85,
    },
    {
      brickId: "6086",
      baseChangeValue: 0.75,
    },
    {
      brickId: "48812",
      baseChangeValue: 0.75,
    },
    {
      brickId: "30464",
      baseChangeValue: 0.5,
    },
    {
      brickId: "30103",
      baseChangeValue: 0.5,
    },
    {
      brickId: "30115",
      baseChangeValue: 0.5,
    },
    {
      brickId: "92084",
      baseChangeValue: 0.5,
    },
    {
      brickId: "80674",
      baseChangeValue: 0.35,
    },
    {
      brickId: "33121",
      baseChangeValue: 0.35,
    },
    {
      brickId: "30238",
      baseChangeValue: 0.35,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3010_10",
    },
    {
      actionId: "auto_collect_3003_10",
    },
    {
      actionId: "auto_collect_3001_10",
    },
    {
      actionId: "auto_collect_3710_10",
    },
    {
      actionId: "auto_collect_3022_10",
    },
    {
      actionId: "auto_collect_3020_10",
    },
    {
      actionId: "increase_capacity_3010_100",
    },
    {
      actionId: "increase_capacity_3003_100",
    },
    {
      actionId: "increase_capacity_3001_100",
    },
    {
      actionId: "increase_capacity_3710_100",
    },
    {
      actionId: "increase_capacity_3022_100",
    },
    {
      actionId: "increase_capacity_3020_100",
    },
    {
      actionId: "upgrade_brickpack_animals_part_one",
    },
    {
      actionId: "upgrade_brickpack_minifig_utensils_part_two",
    },
    {
      actionId: "upgrade_brickpack_bionicles_part_two",
    },
    {
      actionId: "increase_capacity_brickpack_animals_part_one",
    },
    {
      actionId: "increase_capacity_brickpack_minifig_utensils_part_two",
    },
    {
      actionId: "increase_capacity_brickpack_bionicles_part_two",
    },
    {
      actionId: "auto_collect_brickpack_sloped_bricks_part_one",
    },
    {
      actionId: "auto_collect_brickpack_minifig_utensils_part_one",
    },
    {
      actionId: "auto_collect_brickpack_bionicles_part_one",
    },
  ],
  isBrickpack: true,
};

export const BrickPack_MinifigUtensilsPartTwo: ActionInfo = {
  id: "brickpack_minifig_utensils_part_two",
  type: "BrickPack",
  title: "Minifig Utensils #2",
  details: "Minifig Utensils #2",
  cost: [
    {
      brickId: "3020",
      baseChangeValue: 250,
    },
    {
      brickId: "30363",
      baseChangeValue: 150,
    },
    {
      brickId: "42760",
      baseChangeValue: 20,
    },
    {
      brickId: "41671",
      baseChangeValue: 20,
    },
    {
      brickId: "33121",
      baseChangeValue: 7,
    },
    {
      brickId: "30238",
      baseChangeValue: 7,
    },
    {
      brickId: "8534-1",
      baseChangeValue: 20,
      type: "set",
    },
    {
      brickId: "4866-1",
      baseChangeValue: 10,
      type: "set",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "30035",
      baseChangeValue: 0.6,
    },
    {
      brickId: "30173",
      baseChangeValue: 0.6,
    },
    {
      brickId: "76764",
      baseChangeValue: 0.6,
    },
    {
      brickId: "64644",
      baseChangeValue: 0.5,
    },
    {
      brickId: "6246f",
      baseChangeValue: 0.5,
    },
    {
      brickId: "55297",
      baseChangeValue: 0.5,
    },
    {
      brickId: "36752a",
      baseChangeValue: 0.5,
    },
    {
      brickId: "30229",
      baseChangeValue: 0.4,
    },
    {
      brickId: "30194",
      baseChangeValue: 0.4,
    },
    {
      brickId: "64567",
      baseChangeValue: 0.4,
    },
  ],
  actionVisibility: [
    { actionId: "increase_capacity_brickpack_sloped_bricks_part_one_75" },
    { actionId: "increase_capacity_brickpack_minifig_utensils_part_one_75" },
    { actionId: "increase_capacity_brickpack_bionicles_part_one_75" },
    { actionId: "auto_collect_brickpack_sloped_bricks_part_one_15" },
    { actionId: "auto_collect_brickpack_minifig_utensils_part_one_15" },
    { actionId: "auto_collect_brickpack_bionicles_part_one_15" },
    { actionId: "increase_capacity_brickpack_animals_part_one" },
    { actionId: "increase_capacity_brickpack_minifig_utensils_part_two" },
    { actionId: "increase_capacity_brickpack_bionicles_part_two" },
    { actionId: "auto_collect_brickpack_animals_part_one" },
    { actionId: "auto_collect_brickpack_minifig_utensils_part_two" },
    { actionId: "auto_collect_brickpack_bionicles_part_two" },
  ],
  isBrickpack: true,
};

export const BrickPack_BioniclesPartTwo: ActionInfo = {
  id: "brickpack_bionicles_part_two",
  type: "BrickPack",
  title: "Bionicles #2",
  details: "Bionicles #2",
  cost: [
    {
      brickId: "3022",
      baseChangeValue: 250,
    },
    {
      brickId: "4286",
      baseChangeValue: 150,
    },
    {
      brickId: "54271",
      baseChangeValue: 35,
    },
    {
      brickId: "42042",
      baseChangeValue: 35,
    },
    {
      brickId: "92084",
      baseChangeValue: 20,
    },
    {
      brickId: "30103",
      baseChangeValue: 20,
    },
    {
      brickId: "4866-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "4432-1",
      baseChangeValue: 10,
      type: "set",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "32567",
      baseChangeValue: 0.6,
    },
    {
      brickId: "32574",
      baseChangeValue: 0.6,
    },
    {
      brickId: "32570",
      baseChangeValue: 0.6,
    },
    {
      brickId: "32575",
      baseChangeValue: 0.5,
    },
    {
      brickId: "32566",
      baseChangeValue: 0.5,
    },
    {
      brickId: "32565",
      baseChangeValue: 0.5,
    },
    {
      brickId: "32571",
      baseChangeValue: 0.5,
    },
    {
      brickId: "32568",
      baseChangeValue: 0.4,
    },
    {
      brickId: "32505",
      baseChangeValue: 0.4,
    },
    {
      brickId: "32573",
      baseChangeValue: 0.4,
    },
  ],
  actionVisibility: [],
  isBrickpack: true,
};

export const BrickPack_CircularBricks: ActionInfo = {
  id: "brickpack_circular_bricks",
  type: "BrickPack",
  title: "Circular Bricks",
  details: "Circular Bricks",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 500,
    },
    {
      brickId: "3001",
      baseChangeValue: 500,
    },
    {
      brickId: "3039",
      baseChangeValue: 500,
    },
    {
      brickId: "32505",
      baseChangeValue: 7,
    },
    {
      brickId: "32571",
      baseChangeValue: 7,
    },
    {
      brickId: "4866-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "4740",
      baseChangeValue: 0.6,
    },
    {
      brickId: "6014b",
      baseChangeValue: 0.6,
    },
    {
      brickId: "3960",
      baseChangeValue: 0.6,
    },
    {
      brickId: "50990b",
      baseChangeValue: 0.5,
    },
    {
      brickId: "2489",
      baseChangeValue: 0.5,
    },
    {
      brickId: "30139",
      baseChangeValue: 0.5,
    },
    {
      brickId: "6222",
      baseChangeValue: 0.5,
    },
    {
      brickId: "41531",
      baseChangeValue: 0.4,
    },
    {
      brickId: "30360",
      baseChangeValue: 0.4,
    },
    {
      brickId: "4285b",
      baseChangeValue: 0.4,
    },
  ],
  actionVisibility: [
    { actionId: "increase_capacity_brickpack_animals_part_one_75" },
    { actionId: "increase_capacity_brickpack_minifig_utensils_part_two_75" },
    { actionId: "increase_capacity_brickpack_bionicles_part_two_75" },
    { actionId: "auto_collect_brickpack_animals_part_one_15" },
    { actionId: "auto_collect_brickpack_minifig_utensils_part_two_15" },
    { actionId: "auto_collect_brickpack_bionicles_part_two_15" },
  ],
  isBrickpack: true,
};

export const BrickPack_MinifigHair: ActionInfo = {
  id: "brickpack_minifig_hair",
  type: "BrickPack",
  title: "Minifig Hair",
  details: "Minifig Hair",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 1000,
    },
    {
      brickId: "32575",
      baseChangeValue: 35,
    },
    {
      brickId: "32574",
      baseChangeValue: 35,
    },
    {
      brickId: "3960",
      baseChangeValue: 7,
    },
    {
      brickId: "41531",
      baseChangeValue: 7,
    },
    {
      brickId: "30139",
      baseChangeValue: 7,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 50,
      type: "set",
    },
    {
      brickId: "4432-1",
      baseChangeValue: 35,
      type: "set",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "3901",
      baseChangeValue: 0.6,
    },
    {
      brickId: "62696",
      baseChangeValue: 0.6,
    },
    {
      brickId: "53982",
      baseChangeValue: 0.6,
    },
    {
      brickId: "53981",
      baseChangeValue: 0.5,
    },
    {
      brickId: "26139",
      baseChangeValue: 0.5,
    },
    {
      brickId: "42444",
      baseChangeValue: 0.5,
    },
    {
      brickId: "30410",
      baseChangeValue: 0.5,
    },
    {
      brickId: "87991",
      baseChangeValue: 0.4,
    },
    {
      brickId: "13768",
      baseChangeValue: 0.4,
    },
    {
      brickId: "37784",
      baseChangeValue: 0.4,
    },
  ],
  actionVisibility: [],
  isBrickpack: true,
};

export const BrickPack_TechnicBricks: ActionInfo = {
  id: "brickpack_technic_bricks",
  type: "BrickPack",
  title: "Technic Bricks",
  details: "Technic Bricks",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 5000,
    },
    {
      brickId: "3004",
      baseChangeValue: 3500,
    },
    {
      brickId: "3022",
      baseChangeValue: 3500,
    },
    {
      brickId: "3710",
      baseChangeValue: 3500,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "3713",
      baseChangeValue: 0.6,
    },
    {
      brickId: "3749",
      baseChangeValue: 0.6,
    },
    {
      brickId: "24316",
      baseChangeValue: 0.6,
    },
    {
      brickId: "73230",
      baseChangeValue: 0.5,
    },
    {
      brickId: "3701",
      baseChangeValue: 0.5,
    },
    {
      brickId: "32174",
      baseChangeValue: 0.5,
    },
    {
      brickId: "32034",
      baseChangeValue: 0.5,
    },
    {
      brickId: "3648",
      baseChangeValue: 0.4,
    },
    {
      brickId: "3736",
      baseChangeValue: 0.4,
    },
    {
      brickId: "32168",
      baseChangeValue: 0.4,
    },
  ],
  actionVisibility: [
    { actionId: "increase_capacity_brickpack_circular_bricks_75" },
    { actionId: "increase_capacity_brickpack_minifig_hair_75" },
    { actionId: "increase_capacity_brickpack_technic_bricks_75" },
    { actionId: "increase_capacity_brickpack_minifig_headgear_75" },
    { actionId: "auto_collect_brickpack_circular_bricks_15" },
    { actionId: "auto_collect_brickpack_minifig_hair_15" },
    { actionId: "auto_collect_brickpack_technic_bricks_15" },
    { actionId: "auto_collect_brickpack_minifig_headgear_15" },
    { actionId: "auto_collect_brickpack_animals_part_one_75" },
    { actionId: "auto_collect_brickpack_minifig_utensils_part_two_75" },
    { actionId: "auto_collect_brickpack_bionicles_part_two_75" },
  ],
  isBrickpack: true,
};

export const BrickPack_MinifigHeadgear: ActionInfo = {
  id: "brickpack_minifig_headgear",
  type: "BrickPack",
  title: "Minifig Headgear",
  details: "Minifig Headgear",
  cost: [
    {
      brickId: "30139",
      baseChangeValue: 50,
    },
    {
      brickId: "6222",
      baseChangeValue: 50,
    },
    {
      brickId: "41531",
      baseChangeValue: 50,
    },
    {
      brickId: "30360",
      baseChangeValue: 50,
    },
    {
      brickId: "26139",
      baseChangeValue: 25,
    },
    {
      brickId: "53981",
      baseChangeValue: 25,
    },
    {
      brickId: "87991",
      baseChangeValue: 25,
    },
    {
      brickId: "37784",
      baseChangeValue: 25,
    },
    {
      brickId: "3648",
      baseChangeValue: 7,
    },
    {
      brickId: "73230",
      baseChangeValue: 7,
    },
  ],
  costIncrement: 0,
  outcome: [
    {
      brickId: "3898",
      baseChangeValue: 0.6,
    },
    {
      brickId: "30202",
      baseChangeValue: 0.6,
    },
    {
      brickId: "x164",
      baseChangeValue: 0.6,
    },
    {
      brickId: "3485",
      baseChangeValue: 0.5,
    },
    {
      brickId: "x52",
      baseChangeValue: 0.5,
    },
    {
      brickId: "2528",
      baseChangeValue: 0.5,
    },
    {
      brickId: "3624",
      baseChangeValue: 0.5,
    },
    {
      brickId: "30325",
      baseChangeValue: 0.4,
    },
    {
      brickId: "30167",
      baseChangeValue: 0.4,
    },
    {
      brickId: "30381",
      baseChangeValue: 0.4,
    },
  ],
  actionVisibility: [],
  isBrickpack: true,
};
